import { Fragment } from "react";
import ReactDOM from "react-dom";
import { useDispatch } from "react-redux";
import { uiActions } from "../../../store/Ui-slice";


const Backdrop = (props: any) => {
  const dispatch = useDispatch();

  const toggleHideModalHandler = () => {
    dispatch(uiActions.toggleHambargerModal());
  };
  return (
    <div
      onClick={toggleHideModalHandler}
      className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity z-30"
    ></div>
  );
};

const ModalOverlay = (props: any) => {
  return (
    <div>
      <div>{props.children}</div>
    </div>
  );
};
const portalElement: any = document.getElementById("cartOverlays");
const MainModal = (props: any) => {
  return (
    <Fragment>
      {ReactDOM.createPortal(<Backdrop />, portalElement)}
      {ReactDOM.createPortal(
        <ModalOverlay>{props.children}</ModalOverlay>,
        portalElement
      )}
    </Fragment>
  );
};

export default MainModal;